import { memo, useEffect, useState } from 'react'

import { nextClaimTime } from 'src/util/staking/staking.helpers'

const NextPaymentTimer = () => {
  const [nextPaymentTime, setNextPaymentTime] = useState(nextClaimTime())
  useEffect(() => {
    const nextPaymentIntervalTimer = setInterval(
      () => setNextPaymentTime(nextClaimTime()),
      1000
    )
    return () => {
      clearInterval(nextPaymentIntervalTimer)
    }
  }, [])

  return <>{nextPaymentTime}</>
}

export default memo(NextPaymentTimer)
